"use client";
import { useScroll, useTransform } from "motion/react";
import { useRef, useState } from "react";
import { motion } from "motion/react";

import { cn } from "@/lib/utils";

export const ParallaxScroll = ({
  images,
  className,
}: {
  images: string[];
  className?: string;
}) => {
  const gridRef = useRef<any>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const { scrollYProgress } = useScroll({
    target: gridRef,
    offset: ["start end", "end start"]
  });

  const translateFirst = useTransform(scrollYProgress, [0, 1], [0, -100]);
  const translateSecond = useTransform(scrollYProgress, [0, 1], [0, 100]);
  const translateThird = useTransform(scrollYProgress, [0, 1], [0, -100]);

  const third = Math.ceil(images.length / 3);

  const firstPart = images.slice(0, third);
  const secondPart = images.slice(third, 2 * third);
  const thirdPart = images.slice(2 * third);

  return (
    <>
      <div
        className={cn("w-full", className)}
        ref={gridRef}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-start max-w-6xl mx-auto gap-8 py-20 px-10">
          <div className="grid gap-8">
            {firstPart.map((el, idx) => (
              <motion.div
                style={{ y: translateFirst }}
                key={"grid-1" + idx}
                className="cursor-pointer w-full"
                onClick={() => setSelectedImage(el)}
              >
                <img
                  src={el}
                  className="h-80 w-full object-cover object-left-top rounded-lg !m-0 !p-0 hover:scale-105 transition-transform duration-300"
                  height="400"
                  width="400"
                  alt="gallery image"
                />
              </motion.div>
            ))}
          </div>
          <div className="grid gap-8">
            {secondPart.map((el, idx) => (
              <motion.div
                style={{ y: translateSecond }}
                key={"grid-2" + idx}
                className="cursor-pointer w-full"
                onClick={() => setSelectedImage(el)}
              >
                <img
                  src={el}
                  className="h-80 w-full object-cover object-left-top rounded-lg !m-0 !p-0 hover:scale-105 transition-transform duration-300"
                  height="400"
                  width="400"
                  alt="gallery image"
                />
              </motion.div>
            ))}
          </div>
          <div className="grid gap-8">
            {thirdPart.map((el, idx) => (
              <motion.div
                style={{ y: translateThird }}
                key={"grid-3" + idx}
                className="cursor-pointer w-full"
                onClick={() => setSelectedImage(el)}
              >
                <img
                  src={el}
                  className="h-80 w-full object-cover object-left-top rounded-lg !m-0 !p-0 hover:scale-105 transition-transform duration-300"
                  height="400"
                  width="400"
                  alt="gallery image"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-4xl max-h-full">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-10 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
            >
              ✕
            </button>
            <img
              src={selectedImage}
              alt="enlarged gallery image"
              className="max-w-full max-h-full object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </>
  );
};
